module.exports = __webpack_public_path__ + "images/emoji/pill.2f716bf4723f6c1e6096.png";